module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-12-887eb23b52c3bf19685fd130d50ff329.jpg";